export default __webpack_public_path__ + "9b4cc71b392c11f5a2d438c3b891da89.png";